import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in all fields.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent — we'll get back to you soon.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Couldn't send your message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" data-testid="contact" className="relative bg-[#0a0a0a] py-24 md:py-36 border-t border-[#1a1a1a]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <motion.div
          className="lg:col-span-5"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="label mb-5">Reach Out</p>
          <h2 className="font-display uppercase text-white leading-[0.95] text-4xl sm:text-6xl">
            Let's <span className="text-green glow-green">talk</span>
          </h2>
          <p className="font-sub text-lg text-zinc-400 mt-6 font-light max-w-md">
            Partner with us, donate supplies, or just say hello. Drop a message and our team
            will reply.
          </p>
        </motion.div>

        <motion.form
          onSubmit={submit}
          data-testid="contact-form"
          className="lg:col-span-7"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <input data-testid="contact-name" className="field" placeholder="Your name" value={form.name} onChange={set("name")} />
            <input data-testid="contact-email" type="email" className="field" placeholder="Your email" value={form.email} onChange={set("email")} />
          </div>
          <textarea data-testid="contact-message" className="field mt-6" rows={4} placeholder="Your message" value={form.message} onChange={set("message")} />
          <button
            data-testid="contact-submit"
            disabled={loading}
            className="btn-fill mt-8 border border-green text-green font-sub font-semibold text-lg px-8 py-4 rounded-full flex items-center gap-2 disabled:opacity-60"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : <Send size={18} />}
            {loading ? "Sending…" : "Send message"}
          </button>
        </motion.form>
      </div>
    </section>
  );
};
